import { render, staticRenderFns } from "./tryher-review-grid.vue?vue&type=template&id=e6240968&scoped=true&"
import script from "./tryher-review-grid.vue?vue&type=script&lang=js&"
export * from "./tryher-review-grid.vue?vue&type=script&lang=js&"
import style0 from "./tryher-review-grid.vue?vue&type=style&index=0&id=e6240968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6240968",
  null
  
)

export default component.exports